import { userService, UserApiResponse } from '@/services/userService';

export const getUserFullName = (user: UserApiResponse): string => {
    if (user.givenName && user.surname) return `${user.givenName} ${user.surname}`;
    return user.givenName || user.surname || user.displayName || '-';
};

export const createOrUpdateUser = async (user: UserApiResponse) => {
    if (user.id) {
        await userService.update(user.id, user);
    } else {
        await userService.create(user);
    }
};
